(() => {
  const mobile = matchMedia('(max-width: 699px)');
  function update() {
    document.querySelectorAll('[data-voux-mobile-cart]').forEach(bar => {
      const form = document.getElementById(bar.getAttribute('form'));
      if (!form) return;
      const mainButton = document.querySelector('button[type="submit"][form="' + form.id + '"]:not(product-sticky-bar button)') || form.querySelector('button[type="submit"]');
      if (!mainButton) return;
      const rect = mainButton.getBoundingClientRect();
      const visible = rect.bottom > 0 && rect.top < innerHeight && rect.width > 0;
      const overlay = Array.from(document.querySelectorAll('cart-drawer[open], quick-buy-drawer[open], dialog[open], [role="dialog"][aria-modal="true"]:not([hidden])')).some(el => el.getBoundingClientRect().height > 0 && getComputedStyle(el).visibility !== 'hidden');
      const editing = document.activeElement && document.activeElement.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]),textarea,select');
      bar.setAttribute('data-voux-visible', String(mobile.matches && !visible && !overlay && !editing));
      const submit = bar.querySelector('button[type="submit"]');
      if (submit && submit.disabled !== mainButton.disabled) submit.disabled = mainButton.disabled;
      const label = bar.querySelector('.v-stack');
      const selectedPlan = form.querySelector('[name="selling_plan"]');
      if (label) label.setAttribute('data-voux-option', selectedPlan && selectedPlan.value ? bar.dataset.subscriptionLabel : bar.dataset.onetimeLabel);
    });
  }
  let queued = false;
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; update(); }); } };
  document.addEventListener('DOMContentLoaded', () => {
    update();
    new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['open','disabled','aria-hidden','aria-modal']});
  });
  addEventListener('scroll', schedule, {passive:true});
  addEventListener('resize', schedule);
  document.addEventListener('change', schedule);
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
})();
